export default __webpack_public_path__ + "static/media/dessert2.25f0f64c.jpg";